import sys from '@/common/js/sys'
import request from '@/common/js/request'
import { Message, MessageBox  } from 'element-ui'
const util = {
    //对象转字符串
	objToString: function (value) {
        if(value){
            return JSON.stringify(value);
        }else{
            return '';
        }
    },
    //字符串转对象
	stringToObj: function (value) {
        if(value){
            return JSON.parse(value);
        }else{
            return null;
        }
	},
    //list 转成 str   逗号隔开
    listToStr:function(objList){
        let ids = '';
        for (let i = 0; i < objList.length; i++) {
            ids += objList[i] + ',';
        }
        if (ids != '') {
            ids = ids.substr(0, ids.length - 1);
        }
        return ids;
    },
    //后台图片上传控件图片转换
    convertImgUrl(url,defaultImgUrl){
        if( url){
            if(url.indexOf('hhcommon')>-1){
              url = sys.config.basePath+ url;
            }else if(url.indexOf('/')>-1){
                url = sys.config.filePath+ url;
            }else{
               url = sys.config.fileRequestPath+ url;
            }
        }else{
            if(defaultImgUrl){
                url = defaultImgUrl;
            }else{
                url = "static/common/images/default.png";
            }
        }
        return url;
    },
    //ueditor控件输入的内容展示用这个方法转换一下html
    convertEditorHtml(str) {
        if(str){
            return str.replace(/\/uploadfile/g,sys.config.filePath)
            .replace(/\/hhcommon/g,sys.config.commonPath)
            .replace(new RegExp("<embed ","g"),'<video controls="controls" ')
            .replace(new RegExp('allowfullscreen="true"/>',"g"),'allowfullscreen="true"></video>');
        }else{
            return '';
        }
    },
    //TextArea控件输入的内容展示用这个方法转换一下
    convertTextArea(str) {
        if(str){
            return str.replace(/\n/g,'<br>');
        }else{
            return '';
        }
    },
    //下载
    download(url){
        var form = document.getElementById('system_open_page_form');
		if (form == null) {
			var bodys = document.getElementsByTagName('body');
			form = document.createElement('form');
			form.setAttribute('id', 'system_open_page_form');
			form.setAttribute('method', 'post');
			form.setAttribute('target', '_blank');
			bodys[0].appendChild(form);
		}
		form.target = '_blank';
		form.action = url;
		form.submit();
    },
    //下载密码
    downloadPassword(id){
        request.post('public/api/system/file/isPassword.request',{id:id}).then(data => {
            if(data.password){
                  MessageBox.prompt('请输入密码',{inputType:'password',closeOnClickModal:false}).then(({ value }) => {
                    request.post('public/api/system/file/asPassword.request',{id:id,password:value}).then(data2 => {
                        if(data2.password){
                            this.download(sys.config.fileRequestPath+id+'&password='+value);
                        }else{
                            sys.dialog.errormsg("密码错误");
                        }
                    });
                  }).catch(() => {
                  });
            }else{
                this.download(sys.config.fileRequestPath+id);
            }
        });

    },
    //字符串转数字
    toInt(str) {
        if (str) {
            try{
                return parseInt(str);
            }catch(e){
                return 0;
            }
        } else {
            return 0;
        }
    },
     //数据转二维码  图片地址
	getQrCodeUrl: function (param) {
        return sys.config.apiPath+'public/api/system/tool/qrCode.request?id='+encodeURIComponent(param);
    },
     //获取logo URL
	getLogoUrl: function () {
        return sys.config.apiPath+'public/api/system/tool/logo.request';
    },
    browser: {
        getWidth : function() {
            if (window.ActiveXObject) {
                if (document.documentElement == null) {
                    return null;
                }
                return document.documentElement.clientWidth;
            } else {
                if (document.body == null) {
                    return null;
                }
                return document.body.clientWidth;
            }
        },
        getHeight : function() {
            if (window.ActiveXObject) {
                if (document.documentElement == null) {
                    return null;
                }
                return document.documentElement.clientHeight;
            } else {
                if (document.body == null) {
                    return null;
                }
                return document.body.clientHeight;
            }
        }
    },
    replaceText(text) {//富文本内容去除标签及空格
      var newText = text.replace(/<[^>]+>/g, "").replace(/&nbsp;/g,'');
      return newText;
    },
    openwin(pageURL, config) {
		config = config || {};
		var fulls = "left=0,screenX=0,top=0,screenY=0,scrollbars=1"; // 定义弹出窗口的参数
		if (window.screen) {
			var ah = screen.availHeight - 65;
			var aw = screen.availWidth - 10;
			fulls += ",height=" + ah;
			fulls += ",innerHeight=" + ah;
			fulls += ",width=" + aw;
			fulls += ",innerWidth=" + aw;
			fulls += ",resizable"
		} else {
			fulls += ",resizable"; // 对于不支持screen属性的浏览器，可以手工进行最大化。 manually
		}
		var name = (config.id || new Date().getTime()) + '';
		name = ('name' + name).replace(/-/g, '').replace(/_/g, '');
		var subwin = window.open(pageURL, name, fulls);
		subwin.focus();
		return subwin;
    }
}
export default util



// WEBPACK FOOTER //
// ./src/common/js/util.js